<template>
    <div class="stars">
        <figure
            v-for="(star, index) in stars"
            :key="index"
            class="star"
            :style="{
                animationDelay: star.animationDelay + 's',
                left: star.left + '%',
                top: star.top + '%',
            }"
        >
            <figure class="star-top"></figure>
            <figure class="star-bottom"></figure>
        </figure>
    </div>
</template>

<script>
    export default {
        name: 'Stars',
        props: {
            limit: {
                type: Number,
                default: 100,
            },
        },
        setup(props) {
            const stars = [];
            const rand = () => {
                return Math.random();
            };
            for (let i = 0; i <= props.limit; i++) {
                let animationDelay = rand(),
                    counter,
                    done = false,
                    fails = 0,
                    left = 0,
                    top = 0;
                do {
                    top = rand() * 100;
                    left = rand() * 100;
                    counter = stars.length;
                    // Avoid putting stars too close to each other
                    for (let j = 0; j < stars.length; j++) {
                        let deltaLeft = stars[j].left - left;
                        let deltaTop = stars[j].top - top;
                        if (Math.sqrt(deltaLeft * deltaLeft + deltaTop * deltaTop) < 10) {
                            break;
                        } else {
                            counter--;
                        }
                    }
                    if (0 === counter) {
                        done = true;
                    } else {
                        // Keep count of fails as a safeguard
                        fails++;
                    }
                } while (!done && fails < 5);
                if (done) {
                    stars.push({
                        animationDelay,
                        left,
                        top,
                    });
                }
            }

            return {
                stars,
            };
        },
    };
</script>

<style scoped>
    @keyframes glitter {
        0% {
            transform: scale(1);
            opacity: 0.8;
        }
        25% {
            transform: scale(0.5);
            opacity: 0;
        }
        50% {
            transform: scale(1);
            opacity: 0.8;
        }
        75% {
            transform: scale(0.5);
            opacity: 0;
        }
        100% {
            transform: scale(1);
            opacity: 0.8;
        }
    }
    .stars {
        bottom: 0;
        left: 0;
        overflow: hidden;
        position: absolute;
        right: 0;
        top: 0;
        z-index: -1;
    }
    .star {
        animation: glitter 4.5s linear 0s infinite normal;
        background: #f6f6f6;
        border-radius: 50%;
        display: block;
        filter: blur(2px);
        height: 24px;
        left: 50%;
        overflow: hidden;
        position: absolute;
        top: 50%;
        width: 24px;
    }
</style>
